import script from "./SideDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./SideDrawer.vue?vue&type=script&setup=true&lang=js"

import "./SideDrawer.vue?vue&type=style&index=0&id=2dd5989c&lang=scss"

const __exports__ = script;

export default __exports__